/* =============================================
   LE FUMOIR — THEME JAVASCRIPT
   ============================================= */

document.addEventListener('DOMContentLoaded', function () {

  // --- FIXED HEADER: offset body padding ---
  const header = document.querySelector('.site-header');

  function setHeaderOffset() {
    const headerH = header ? header.offsetHeight : 0;
    document.documentElement.style.setProperty('--header-offset', headerH + 'px');
  }

  if (header) {
    setHeaderOffset();
    window.addEventListener('resize', setHeaderOffset, { passive: true });
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 50);
    }, { passive: true });
  }

  // --- SCROLL REVEAL ---
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });

  document.querySelectorAll('.reveal').forEach(el => revealObserver.observe(el));

  // --- COUNTDOWN TIMER ---
  function getNextFriday() {
    const now = new Date();
    const day = now.getDay();
    const daysUntilFriday = (4 - day + 7) % 7 || 7;
    const friday = new Date(now);
    friday.setDate(now.getDate() + daysUntilFriday);
    friday.setHours(23, 59, 59, 0);
    return friday;
  }

  function updateCountdown() {
    const elements = document.querySelectorAll('[data-countdown]');
    if (!elements.length) return;

    const target = getNextFriday();
    const now    = new Date();
    const diff   = target - now;
    if (diff <= 0) return;

    const days    = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours   = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    elements.forEach(el => {
      const d = el.querySelector('[data-days]');
      const h = el.querySelector('[data-hours]');
      const m = el.querySelector('[data-minutes]');
      const s = el.querySelector('[data-seconds]');
      if (d) d.textContent = String(days).padStart(2, '0');
      if (h) h.textContent = String(hours).padStart(2, '0');
      if (m) m.textContent = String(minutes).padStart(2, '0');
      if (s) s.textContent = String(seconds).padStart(2, '0');
    });
  }

  updateCountdown();
  setInterval(updateCountdown, 1000);

  // --- CART DRAWER ---
  const cartDrawer     = document.getElementById('cart-drawer');
  const cartDrawerBody = document.getElementById('cart-drawer-body');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    fetchCart();
  }

  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  // Expose openCart for experience bundle and other sections
  window.openCart = openCart;

  async function fetchCart() {
    try {
      const res  = await fetch('/cart.js');
      const cart = await res.json();
      renderCart(cart);
    } catch (e) {
      console.error('Cart fetch failed', e);
    }
  }

  function formatMoney(cents) {
    const currency = (window.LeFumoir && window.LeFumoir.currency) || 'AED';
    const amount   = cents / 100;
    const str      = amount % 1 === 0 ? amount.toFixed(0) : amount.toFixed(2);
    return currency + '\u00a0' + str;
  }

  function renderCart(cart) {
    if (!cartDrawerBody) return;

    const freeDeliveryThreshold = (window.LeFumoir && window.LeFumoir.freeDeliveryThreshold) || 25000;

    if (cart.item_count === 0) {
      cartDrawerBody.innerHTML = `
        <div class="cart-empty" style="text-align:center;padding:60px 20px;">
          <p style="font-family:var(--font-serif);font-size:1.2rem;color:var(--color-deep-blue);margin-bottom:8px;">Your table is still waiting to be set.</p>
          <p style="font-size:13px;color:var(--color-silver);margin-bottom:32px;">Discover our premium smoked salmon range.</p>
          <a href="/collections/all" class="btn btn--primary">Explore the Range</a>
        </div>`;
      return;
    }

    const itemsHTML = cart.items.map(item => `
      <div class="cart-item" data-id="${item.key}" style="display:flex;gap:16px;padding:16px 0;border-bottom:1px solid var(--color-silver-light);">
        <div style="width:72px;height:72px;border-radius:6px;overflow:hidden;background:var(--color-cream);flex-shrink:0;">
          <img src="${item.image}" alt="${item.title}" style="width:100%;height:100%;object-fit:cover;">
        </div>
        <div style="flex:1;">
          <p style="font-family:var(--font-serif);font-size:0.9rem;margin-bottom:4px;">${item.product_title}</p>
          <p style="font-size:11px;color:var(--color-silver);margin-bottom:8px;">${item.variant_title !== 'Default Title' ? item.variant_title : ''}</p>
          <div style="display:flex;align-items:center;justify-content:space-between;">
            <div style="display:flex;align-items:center;gap:8px;border:1px solid var(--color-silver-light);border-radius:4px;overflow:hidden;">
              <button data-cart-dec data-key="${item.key}" data-qty="${item.quantity - 1}" style="padding:6px 10px;font-size:14px;color:var(--color-deep-blue);" aria-label="Decrease">&#8722;</button>
              <span style="font-size:13px;min-width:20px;text-align:center;">${item.quantity}</span>
              <button data-cart-inc data-key="${item.key}" data-qty="${item.quantity + 1}" style="padding:6px 10px;font-size:14px;color:var(--color-deep-blue);" aria-label="Increase">+</button>
            </div>
            <span style="font-family:var(--font-serif);font-size:0.95rem;">${formatMoney(item.final_line_price)}</span>
          </div>
        </div>
      </div>
    `).join('');

    const remaining      = freeDeliveryThreshold - cart.total_price;
    const drawerNote     = window.__cartDrawerNote || '';
    const drawerNoteHTML = drawerNote ? `<p style="font-size:11px;color:#80828f;text-align:left;margin:6px 0 0;font-style:italic;">${drawerNote}</p>` : '';
    const deliveryBarHTML = remaining > 0
      ? `<div style="background:var(--color-cream);padding:12px 16px;border-radius:6px;margin-bottom:16px;font-size:12px;text-align:center;">
           Add <strong>${formatMoney(remaining)}</strong> more for complimentary cold-chain delivery
           <div style="height:3px;background:var(--color-silver-light);border-radius:3px;margin-top:8px;">
             <div style="height:100%;background:var(--color-oak);width:${Math.min(100, (cart.total_price / freeDeliveryThreshold) * 100)}%;border-radius:3px;transition:width 0.4s;"></div>
           </div>
           ${drawerNoteHTML}
         </div>`
      : `<div style="background:rgba(42,102,68,0.06);padding:10px 16px;border-radius:6px;margin-bottom:16px;font-size:12px;color:var(--color-organic-green);text-align:center;font-weight:500;">
           &#10003; Complimentary cold-chain delivery included
         </div>`;

    cartDrawerBody.innerHTML = `
      <div style="margin-bottom:16px;">${deliveryBarHTML}</div>
      <div class="cart-items">${itemsHTML}</div>
      <div style="padding:20px 0;border-top:1px solid var(--color-silver-light);margin-top:8px;">
        <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:20px;">
          <span style="font-size:12px;font-weight:500;letter-spacing:0.1em;text-transform:uppercase;color:var(--color-silver);">Subtotal</span>
          <span style="font-family:var(--font-serif);font-size:1.2rem;">${formatMoney(cart.total_price)}</span>
        </div>
        <a href="/cart" class="btn btn--primary btn--full btn--lg" style="display:flex;justify-content:center;">Proceed to Order</a>
      </div>`;
  }

  // Cart quantity / remove — event delegation so CSP is never triggered by inline onclick
  if (cartDrawerBody) {
    cartDrawerBody.addEventListener('click', function (e) {
      const btn = e.target.closest('[data-cart-dec],[data-cart-inc]');
      if (!btn) return;
      const key = btn.dataset.key;
      const qty = parseInt(btn.dataset.qty, 10);
      if (key) updateCartItem(key, qty);
    });
  }

  async function updateCartItem(key, qty) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      fetchCart();
      updateCartCount();
    } catch (e) { console.error(e); }
  }

  async function updateCartCount() {
    try {
      const res  = await fetch('/cart.js');
      const cart = await res.json();
      document.querySelectorAll('.cart-count').forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
      });
    } catch (e) {}
  }

  // --- CART PAGE: qty steppers + remove ---
  const cartPageItems = document.querySelector('.cart-page__items');
  if (cartPageItems) {
    cartPageItems.addEventListener('click', async function (e) {
      // Qty stepper
      const stepBtn = e.target.closest('.qty-stepper__btn[data-key]');
      if (stepBtn) {
        const key     = stepBtn.dataset.key;
        const change  = parseInt(stepBtn.dataset.change, 10);
        const valEl   = stepBtn.closest('.qty-stepper').querySelector('.qty-stepper__val');
        const current = parseInt(valEl ? valEl.textContent : 1, 10);
        const newQty  = Math.max(0, current + change);
        stepBtn.disabled = true;
        try {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: newQty })
          });
          window.location.reload();
        } catch (err) { stepBtn.disabled = false; }
        return;
      }
      // Remove button
      const removeBtn = e.target.closest('.cart-line__remove[data-key]');
      if (removeBtn) {
        const key = removeBtn.dataset.key;
        removeBtn.disabled = true;
        try {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: 0 })
          });
          window.location.reload();
        } catch (err) { removeBtn.disabled = false; }
      }
    });
  }

  // Cart trigger (header cart icon)
  document.querySelectorAll('[data-cart-trigger]').forEach(el => {
    el.addEventListener('click', (e) => { e.preventDefault(); openCart(); });
  });

  if (cartDrawer) {
    cartDrawer.querySelector('.cart-drawer__overlay')?.addEventListener('click', closeCart);
    cartDrawer.querySelector('.cart-drawer__close')?.addEventListener('click', closeCart);
  }

  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeCart(); });

  // --- ADD TO CART --- (handled below in product-page section)

  // --- PURCHASE TOGGLE (one-time vs subscribe) ---
  function getSellingPlanId(productId, freq) {
    const el = document.getElementById('selling-plans-' + productId);
    if (!el) return null;
    try {
      const data    = JSON.parse(el.textContent);
      const allPlans = data.groups.flatMap(g => g.plans);
      const freqMap = { weekly: /week/i, biweekly: /2.?week|bi.?week|fortnig/i, monthly: /month/i };
      const pattern = freqMap[freq] || freqMap.weekly;
      const match   = allPlans.find(p => pattern.test(p.name));
      return match ? match.id : (allPlans[0]?.id || null);
    } catch (e) { return null; }
  }

  function updatePricingDisplay(container, isSubscribe, priceCents) {
    const discount    = parseFloat(container.dataset.subDiscount || 15);
    const oneTimeCents = priceCents !== undefined ? priceCents : parseFloat(container.dataset.priceCents || 0);
    const subCents    = Math.round(oneTimeCents * (1 - discount / 100));
    const priceDisplay = container.querySelector('.price-display__current');
    const saveBadge   = container.querySelector('.price-display__save');
    const currency    = (window.LeFumoir && window.LeFumoir.currency) || 'AED';
    if (priceDisplay) {
      priceDisplay.textContent = currency + '\u00a0' + ((isSubscribe ? subCents : oneTimeCents) / 100).toFixed(0);
    }
    if (saveBadge) saveBadge.style.display = isSubscribe ? 'inline-block' : 'none';
  }

  function syncSellingPlan(form, productId, isSubscribe, freq) {
    form.querySelectorAll('[name="selling_plan"]').forEach(el => el.remove());
    if (!isSubscribe) return;
    const planId = getSellingPlanId(productId, freq);
    if (planId) {
      const input  = document.createElement('input');
      input.type   = 'hidden';
      input.name   = 'selling_plan';
      input.value  = planId;
      form.appendChild(input);
    }
  }

  document.querySelectorAll('.purchase-toggle__btn').forEach(btn => {
    btn.addEventListener('click', function () {
      const container = this.closest('.product-info__pricing');
      if (!container) return;
      container.querySelectorAll('.purchase-toggle__btn').forEach(b => b.classList.remove('active'));
      this.classList.add('active');

      const isSubscribe = this.dataset.type === 'subscribe';
      const freqSelector = container.querySelector('.frequency-selector');
      const productId   = container.dataset.productId;
      const priceCents  = parseFloat(container.dataset.priceCents || 0);
      const activeFreq  = freqSelector?.querySelector('.freq-btn.active')?.dataset.freq || 'weekly';

      if (freqSelector) freqSelector.classList.toggle('visible', isSubscribe);
      updatePricingDisplay(container, isSubscribe, priceCents);

      document.querySelectorAll('[data-product-form]').forEach(form => {
        syncSellingPlan(form, productId, isSubscribe, activeFreq);
      });

      document.querySelectorAll('[data-add-to-cart]').forEach(b => {
        b.textContent = isSubscribe ? 'Subscribe Now' : 'Add to Cart';
      });
    });
  });

  // --- FREQUENCY SELECTOR ---
  document.querySelectorAll('.frequency-selector .freq-btn').forEach(btn => {
    btn.addEventListener('click', function () {
      this.closest('.frequency-selector').querySelectorAll('.freq-btn').forEach(b => b.classList.remove('active'));
      this.classList.add('active');

      const container  = this.closest('.product-info__pricing');
      const productId  = container?.dataset.productId;
      const isSubscribe = container?.querySelector('.purchase-toggle__btn.active')?.dataset.type === 'subscribe';
      if (isSubscribe) {
        document.querySelectorAll('[data-product-form]').forEach(form => {
          syncSellingPlan(form, productId, true, this.dataset.freq);
        });
      }
    });
  });

  // --- VARIANT SELECTOR ---
  document.querySelectorAll('.variant-selector__options .freq-btn').forEach(btn => {
    btn.addEventListener('click', function () {
      this.closest('.variant-selector__options').querySelectorAll('.freq-btn').forEach(b => b.classList.remove('active'));
      this.classList.add('active');

      const variantId  = this.dataset.variantId;
      const priceCents = parseFloat(this.dataset.priceCents || 0);

      document.querySelectorAll('[data-product-form] [name="id"]').forEach(input => {
        input.value = variantId;
      });

      const container = document.querySelector('.product-info__pricing');
      if (container) {
        container.dataset.priceCents = priceCents;
        const isSubscribe = container.querySelector('.purchase-toggle__btn.active')?.dataset.type === 'subscribe';
        updatePricingDisplay(container, isSubscribe, priceCents);
      }

      const stickyPrice = document.querySelector('.sticky-atc__price');
      const currency    = (window.LeFumoir && window.LeFumoir.currency) || 'AED';
      if (stickyPrice) stickyPrice.textContent = currency + '\u00a0' + (priceCents / 100).toFixed(0);
    });
  });

  // --- PRODUCT GALLERY THUMBNAILS ---
  document.querySelectorAll('.product-gallery__thumb').forEach(thumb => {
    thumb.addEventListener('click', function () {
      const gallery = this.closest('.product-gallery');
      const mainImg = gallery?.querySelector('.product-gallery__main img');
      const fullSrc = this.dataset.fullSrc || this.querySelector('img')?.src;
      if (mainImg && fullSrc) {
        mainImg.style.opacity = '0';
        setTimeout(() => { mainImg.src = fullSrc; mainImg.style.opacity = '1'; }, 200);
      }
      gallery?.querySelectorAll('.product-gallery__thumb').forEach(t => t.classList.remove('active'));
      this.classList.add('active');
    });
  });

  // --- STICKY ATC (product page) ---
  const stickyAtc        = document.querySelector('.sticky-atc');
  const addToCartSection = document.querySelector('.product-info');
  if (stickyAtc && addToCartSection) {
    const observer = new IntersectionObserver((entries) => {
      stickyAtc.classList.toggle('visible', !entries[0].isIntersecting);
    }, { threshold: 0 });
    observer.observe(addToCartSection);
  }

  // --- ANNOUNCEMENT BAR ROTATION ---
  const trackItems = document.querySelectorAll('.announcement-bar__item');
  if (trackItems.length > 0) {
    let current = 0;
    trackItems[0].classList.add('active');
    if (trackItems.length > 1) {
      setInterval(() => {
        trackItems[current].classList.remove('active');
        current = (current + 1) % trackItems.length;
        trackItems[current].classList.add('active');
      }, 4000);
    }
  }

  // --- EXPERIENCE BUNDLE: ADD ALL TO CART ---
  document.querySelectorAll('[data-experience-add]').forEach(btn => {
    btn.addEventListener('click', async function () {
      const ids = this.dataset.experienceAdd.split(',').filter(Boolean);
      if (!ids.length) return;

      const label    = this.querySelector('.experience-add__text');
      const original = label ? label.textContent : this.textContent;
      if (label) label.textContent = 'Adding...';
      this.disabled = true;

      const items = ids.map(id => ({ id: parseInt(id, 10), quantity: 1 }));

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!res.ok) throw new Error('Cart add failed');
        if (label) label.textContent = '\u2713 Added to Cart';
        updateCartCount();
        setTimeout(() => openCart(), 400);
        setTimeout(() => { if (label) label.textContent = original; this.disabled = false; }, 1800);
      } catch (e) {
        if (label) label.textContent = 'Error \u2014 Try Again';
        this.disabled = false;
      }
    });
  });

  updateCartCount();

  // --- LOAD MORE ---
  document.querySelectorAll('.load-more-btn').forEach(btn => {
    btn.addEventListener('click', async function () {
      const nextUrl = this.dataset.nextUrl;
      const gridSel = this.dataset.grid;
      const itemSel = this.dataset.item;
      const grid    = document.querySelector(gridSel);
      if (!nextUrl || !grid) return;

      const originalText = this.textContent;
      this.textContent   = 'Loading...';
      this.disabled      = true;

      try {
        const res     = await fetch(nextUrl);
        const html    = await res.text();
        const parser  = new DOMParser();
        const doc     = parser.parseFromString(html, 'text/html');
        const newItems = doc.querySelectorAll(itemSel);

        newItems.forEach(item => {
          item.classList.remove('visible'); // reset reveal so observer can re-fire
          grid.appendChild(item);
        });

        // Re-observe new items for reveal animation
        newItems.forEach(el => {
          if (el.classList.contains('reveal')) revealObserver.observe(el);
        });

        // Update next URL or remove button
        const newBtn = doc.querySelector('.load-more-btn');
        if (newBtn && newBtn.dataset.nextUrl) {
          this.dataset.nextUrl = newBtn.dataset.nextUrl;
          this.textContent     = originalText;
          this.disabled        = false;
        } else {
          this.closest('.load-more-wrap').remove();
        }
      } catch (e) {
        this.textContent = originalText;
        this.disabled    = false;
      }
    });
  });

  // --- RECIPE INGREDIENT: AJAX ADD TO CART ---
  document.querySelectorAll('.recipe-ingredient-atc-form').forEach(form => {
    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      const btn       = this.querySelector('.recipe-ingredient-atc');
      const variantId = this.querySelector('[name="id"]')?.value;
      if (!variantId || !btn) return;

      const original = btn.textContent;
      btn.textContent = 'Adding...';
      btn.disabled = true;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        if (!res.ok) throw new Error();
        btn.textContent = '✓ Added';
        btn.style.background = 'var(--color-oak)';
        btn.style.color = '#fff';
        updateCartCount();
        setTimeout(() => {
          btn.textContent = original;
          btn.style.background = '';
          btn.style.color = '';
          btn.disabled = false;
        }, 2000);
      } catch (e) {
        btn.textContent = 'Error — Try Again';
        btn.disabled = false;
        setTimeout(() => { btn.textContent = original; }, 2000);
      }
    });
  });

  // --- PRODUCT PAGE ---

  // Gallery thumb nav
  const galleryThumbsWrap = document.querySelector('.product-gallery__thumbs-wrap');
  if (galleryThumbsWrap) {
    const mainImg    = document.getElementById('gallery-main-img');
    const thumbsEl   = galleryThumbsWrap.querySelector('.product-gallery__thumbs');
    const prevBtn    = galleryThumbsWrap.querySelector('.product-gallery__thumb-nav--prev');
    const nextBtn    = galleryThumbsWrap.querySelector('.product-gallery__thumb-nav--next');
    const thumbBtns  = galleryThumbsWrap.querySelectorAll('.product-gallery__thumb');

    thumbBtns.forEach(btn => {
      btn.addEventListener('click', function () {
        if (mainImg) {
          mainImg.style.opacity = '0';
          setTimeout(() => {
            mainImg.src = this.dataset.fullSrc;
            mainImg.style.opacity = '1';
          }, 150);
        }
        thumbBtns.forEach(b => b.classList.remove('active'));
        this.classList.add('active');
      });
    });

    if (prevBtn && thumbsEl) {
      prevBtn.addEventListener('click', () => {
        thumbsEl.scrollBy({ left: -160, behavior: 'smooth' });
      });
    }
    if (nextBtn && thumbsEl) {
      nextBtn.addEventListener('click', () => {
        thumbsEl.scrollBy({ left: 160, behavior: 'smooth' });
      });
    }
  }

  // Quantity stepper
  document.querySelectorAll('.product-qty__btn').forEach(btn => {
    btn.addEventListener('click', function () {
      const delta = parseInt(this.dataset.qty, 10);
      const input = this.closest('.product-qty').querySelector('.product-qty__input');
      if (!input) return;
      const newVal = Math.max(1, (parseInt(input.value, 10) || 1) + delta);
      input.value = newVal;

      // Update price display to reflect new quantity
      const pricingEl = document.querySelector('.product-info__pricing');
      const priceEl   = document.getElementById('product-price');
      if (pricingEl && priceEl) {
        const unitCents = parseInt(pricingEl.dataset.priceCents, 10) || 0;
        // Check if subscribe plan is active (selling_plan input present)
        const form      = document.querySelector('[data-product-form]');
        const planInput = form && form.querySelector('input[name="selling_plan"]');
        let displayCents = unitCents;
        if (planInput && planInput.value) {
          const discount = parseInt(pricingEl.dataset.subDiscount, 10) || 15;
          displayCents   = Math.round(unitCents * (1 - discount / 100));
        }
        priceEl.textContent = formatMoney(displayCents * newVal);
      }
    });
  });

  // Normalize initial price display from Shopify's store format (Dhs.) to AED
  (function initPriceDisplay() {
    const pricingEl  = document.querySelector('.product-info__pricing');
    const priceEl    = document.getElementById('product-price');
    const compareEl  = document.getElementById('product-compare-price');
    if (!pricingEl || !priceEl) return;
    const priceCents   = parseInt(pricingEl.dataset.priceCents, 10) || 0;
    if (priceCents) priceEl.textContent = formatMoney(priceCents);
    // Compare price: read from the first selected option if variant select exists
    const varSel = document.getElementById('variant-select');
    if (varSel && compareEl) {
      const opt = varSel.options[varSel.selectedIndex];
      const compareCents = parseInt(opt && opt.dataset.compare, 10) || 0;
      if (compareCents > priceCents) {
        compareEl.textContent = formatMoney(compareCents);
      }
    }
  })();

  // Variant select -> update price display and hidden input
  const variantSelect = document.getElementById('variant-select');
  if (variantSelect) {
    variantSelect.addEventListener('change', function () {
      const opt          = this.options[this.selectedIndex];
      const priceCents   = parseInt(opt.dataset.price, 10) || 0;
      const compareCents = parseInt(opt.dataset.compare, 10) || 0;

      // Update hidden form input
      const variantInput = document.getElementById('variant-id-input');
      if (variantInput) variantInput.value = this.value;

      // Reset qty to 1 on variant change so price display stays correct
      const qtyInput = document.querySelector('.product-qty__input');
      if (qtyInput) qtyInput.value = 1;

      // Update pricing data attrs on wrapper
      const pricingEl = document.querySelector('.product-info__pricing');
      if (pricingEl) pricingEl.dataset.priceCents = priceCents;

      const priceEl = document.getElementById('product-price');
      if (priceEl) priceEl.textContent = formatMoney(priceCents);

      const compareEl = document.getElementById('product-compare-price');
      if (compareEl) {
        if (compareCents > priceCents) {
          compareEl.textContent = formatMoney(compareCents);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }

      // Update subscribe price
      const subDiscount  = parseInt(pricingEl ? pricingEl.dataset.subDiscount : 15, 10) || 15;
      const discountAmt  = Math.round(priceCents * subDiscount / 100);
      const subPrice     = priceCents - discountAmt;
      const subPriceEl   = document.getElementById('sub-display-price');
      const onetimePriceEl = document.getElementById('onetime-display-price');
      if (subPriceEl)     subPriceEl.textContent    = formatMoney(subPrice);
      if (onetimePriceEl) onetimePriceEl.textContent = formatMoney(priceCents);

      const subCompareEl = document.querySelector('.purchase-block--subscribe .purchase-block__price-compare');
      if (subCompareEl) subCompareEl.textContent = formatMoney(priceCents);
    });
  }


  // Add to Cart button (product page AJAX)
  const atcBtn = document.querySelector('[data-add-to-cart]');
  if (atcBtn) {
    atcBtn.addEventListener('click', async function () {
      const btn    = this;
      const label  = btn.querySelector('.product-atc-btn__label');
      const form   = btn.closest('form[data-product-form]');
      if (!form || !label) return;

      const varId     = (form.querySelector('[name="id"]') || {}).value;
      const qty       = (form.querySelector('[name="quantity"]') || {}).value || 1;
      const planInput = form.querySelector('[name="selling_plan"]');
      if (!varId) return;

      const originalLabel = label.textContent;
      label.textContent   = 'Adding...';
      btn.disabled        = true;

      const body = { id: parseInt(varId, 10), quantity: parseInt(qty, 10) };
      if (planInput && planInput.value) body.selling_plan = parseInt(planInput.value, 10);

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body)
        });
        if (!res.ok) throw new Error('cart_add_failed');
        label.textContent = '✓ Added';
        updateCartCount();
        setTimeout(() => openCart(), 400);
      } catch (err) {
        label.textContent = 'Try Again';
      } finally {
        setTimeout(() => {
          label.textContent = originalLabel;
          btn.disabled      = false;
        }, 1500);
      }
    });
  }

  // --- MAILWIZZ EMAIL CAPTURE ---
  document.querySelectorAll('.email-form-mw').forEach(form => {
    const msgEl  = form.querySelector('.email-form-mw__msg');
    const btn    = form.querySelector('[type="submit"]');
    const input  = form.querySelector('[name="email"]');
    const mwUrl  = form.dataset.mwUrl;
    const mwKey  = form.dataset.mwKey;
    const mwList = form.dataset.mwList;

    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      const email = input.value.trim();
      if (!email) return;

      const originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Subscribing…';
      msgEl.style.display = 'none';
      msgEl.className = 'email-form-mw__msg';

      try {
        const endpoint = mwUrl.replace(/\/$/, '') + '/api/lists/' + mwList + '/subscribers';
        const body = new URLSearchParams();
        body.append('EMAIL', email);

        const res = await fetch(endpoint, {
          method: 'POST',
          headers: {
            'X-MW-PUBLIC-KEY': mwKey,
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          body: body.toString()
        });

        const data = await res.json().catch(() => ({}));
        const status = (data.status || '').toLowerCase();

        if (status === 'success' || status === 'subscribed') {
          msgEl.textContent = "✓ You're subscribed!";
          msgEl.classList.add('email-form-mw__msg--success');
          input.value = '';
        } else if (status === 'error' && data.error && /already/i.test(JSON.stringify(data.error))) {
          msgEl.textContent = "You're already subscribed.";
          msgEl.classList.add('email-form-mw__msg--success');
        } else {
          const errMsg = data.error ? JSON.stringify(data.error) : 'Please try again.';
          msgEl.textContent = 'Error: ' + errMsg;
          msgEl.classList.add('email-form-mw__msg--error');
        }
      } catch (err) {
        console.error('[MailWizz]', err);
        msgEl.textContent = 'Could not connect: ' + (err.message || err);
        msgEl.classList.add('email-form-mw__msg--error');
      } finally {
        msgEl.style.display = 'block';
        btn.textContent = originalText;
        btn.disabled = false;
      }
    });
  });

});
